import { render, staticRenderFns } from "./PartyTemplate.vue?vue&type=template&id=36dcfef7"
import script from "./PartyTemplate.vue?vue&type=script&lang=js"
export * from "./PartyTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports